import React from 'react';

import { BsInstagram } from 'react-icons/bs';
import { FaItchIo, FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  const handleFb = () => {
    window.open("https://www.facebook.com/g3pgames/");
  };

  const handleItchio = () => {
    window.open("https://g3pgames.itch.io/");
  };

  const handleInstagram = () => {
    window.open("https://www.instagram.com/g3pgames/");
  };



  return (
    <div className="app__social">
        <div>
            <FaFacebookF onClick={handleFb} />
        </div>
        <div>
            <FaItchIo onClick={handleItchio} />
        </div>
        <div>
            <BsInstagram onClick={handleInstagram} />
        </div>
    </div>
  );
};

export default SocialMedia;